import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './mock.style.css';
import { Helmet } from 'react-helmet-async';
import { Fragment } from 'react';
import FooterNew from '../../components/Footer/section-footer';

const Mock = () => {
  const mockData = [
    {
      title: 'WBCS Mock Test',
      url: 'mock-test/wbcs-mock-test',
    },
    {
      title: 'IAS Mock Test',
      url: 'mock-test/ias-mock-test',
    },
  ];

  return (
    <Fragment>
      <Helmet>
        <title>Mock Test Free | Mock Test Series | Mock Test Online</title>
        <meta
          name="description"
          content="Start with free mock test for WBCS and IAS Prelims exam preparation. Attempt WBCS and IAS online test series to clear the exam."
        />
        <link rel="canonical" href="https://www.ahguide.in/mock-test" />
      </Helmet>

      <div className="section">
        <div className="container">
          <h2 className="heading-secondary">Select your exam category</h2>
          <p className="header-description">
            Click to view all available test series in an exam
          </p>
          <div className="cards-container">
            {mockData.map((data) => {
              const { title, url } = data;
              return (
                <div key={title} className="mock__card">
                  <h3 className="heading-tertiary">{title}</h3>
                  <a className="mock-btn" href={url}>
                    Know more
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <FooterNew />
    </Fragment>
  );
};

export default Mock;
